
import { connect } from 'react-redux';
import { mapStateToSignInProps, mapDispatchToSignInProps } from '../mapToProps.js';
import { LandingPageView } from '../views/loginPage/landingPageView.jsx';
import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

function LandingPage(props) {

    const navigate = useNavigate();

    useEffect(() => {
        if (props.user.status === 'signed-in') {
            navigate('/myClubs'); // Redirect to /myclubs if signed in
        }
    }, [props.user.status, navigate]); 

    const [signToggle, setToggle] = useState("login");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [FName, setFName] = useState("");
    const [LName, setLName] = useState("");
    const [comfirmPassword, setComfirmPassword] = useState("");

    function signInUser(){
        props.signIn({email, password});
    }
    function signUpUser(){
        props.signUp({email, password, comfirmPassword, FName, LName});
    }

    function handleGoogleSignIn(){
        props.signInWithGoogle();
    }
    return (
        <LandingPageView
            signToggle={signToggle}
            toggle={setToggle}
            setEmail={setEmail}
            setPassword={setPassword}
            setFName={setFName}
            setLName={setLName}
            setComfirmPassword={setComfirmPassword}
            signInUser={signInUser}
            signUpUser={signUpUser}  
            user = {props.user}
            clearErrors={() => props.clearErrors()}
            onGoogleSignIn = {handleGoogleSignIn}
            
            
            
        />
    );
}
export default connect(mapStateToSignInProps, mapDispatchToSignInProps)(LandingPage);